import ServicesHero from './components/ServicesHero';
import CategoryGrid from './components/CategoryGrid';
import MinistryConnectionsBanner from './components/MinistryConnectionsBanner';
import ProgramsComparison from './components/ProgramsComparison';
import ServicesFeatures from './components/ServicesFeatures';
import ServicesCTA from './components/ServicesCTA';
import SEOHead from '@/components/feature/SEOHead';

const servicesJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Services | Creative Institute LLC',
  url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services`,
  description: 'Explore all Creative Institute LLC services — in-home programs, off-site services, recording studio, neurodivergent development, ministry connections, and more across North Carolina.',
  mainEntity: {
    '@type': 'EducationalOrganization',
    name: 'Creative Institute LLC',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Creative Institute Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'In-Home Creative Programs' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Off-Site Services' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Recording Studio' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Neurodivergent Development' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Ministry Connections' } },
      ],
    },
  },
};

export default function ServicesPage() {
  return (
    <main>
      <SEOHead
        title="Services | Creative Institute LLC — Mobile Music & Arts NC"
        description="Explore Creative Institute LLC services: in-home music programs, off-site services, recording studio, neurodivergent development, and ministry connections across North Carolina."
        keywords="Creative Institute services, mobile music programs NC, arts education services, recording studio NC, neurodivergent arts program, ministry music connections"
        canonical="/services"
        jsonLd={servicesJsonLd}
      />
      <ServicesHero />
      <CategoryGrid />
      <MinistryConnectionsBanner />
      <ProgramsComparison />
      <ServicesFeatures />
      <ServicesCTA />
    </main>
  );
}
